module.exports = __webpack_public_path__ + "static/media/maps.2faecae9.png";